import React from 'react'
import {Line, Text} from 'react-konva';
export default function Measure({measureState, measureLineWidth, numberSize}) {

    function measuementText(){
        return (Math.hypot(measureState.x2-measureState.x1, measureState.y2-measureState.y1) / 10).toFixed(1) + " cm"
    } 

  return (
      <>
    <Line
        points={[measureState.x1,measureState.y1,measureState.x2,measureState.y2]}     
        stroke='red'
        strokeWidth={measureLineWidth}
        lineCap='round'        
        />        
        {(() => {
            const textWidth = measuementText().length * (numberSize * 0.6); // Rough estimate
            const centerX = (measureState.x1 + measureState.x2) / 2 - textWidth / 2;
            return (
                <Text x={centerX} y={(measureState.y1 + measureState.y2) /2 - numberSize - 50} fontSize={numberSize} text={measuementText()} fill='black' />
            );
        })()}
    
    </>
  )
}
